import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Modal, Alert, Price, Button } from '@grandvisionhq/common';
import { Select } from '@grandvisionhq/forms';
import { useIntl } from '@grandvisionhq/state';

const ChangeQuantityModal = ({ className , onCancel , onEditQuantity , maxQuantity , isLoading , errorMessage , totalPricePerInstallment ,  })=>{
    const intl = useIntl();
    const quantityRange = Array.from({
        length: maxQuantity
    }, (_, i)=>i + 1
    );
    const formattedQuantities = quantityRange.reduce((acc, quantity)=>{
        const quantityLabel = quantity === 1 ? intl.getLabel('products.box') : intl.getLabel('products.boxes');
        return swcHelpers.objectSpread({}, acc, {
            [`${quantity} ${quantityLabel}`]: quantity
        });
    }, {});
    const initialOptionKey = Object.keys(formattedQuantities)[0];
    const [quantity1, setQuantity] = React.useState(formattedQuantities[initialOptionKey]);
    const initialValue = React.useMemo(()=>({
            value: initialOptionKey
        })
    , [
        initialOptionKey
    ]);
    const onSelectChange = (quantity)=>{
        setQuantity(quantity);
    };
    const handleSubmit = ()=>{
        onEditQuantity(quantity1);
    };
    const buttonCaption = isLoading ? intl.getLabel('common.loadingText') : intl.getLabel('account.action.changeQuantity');
    const footerButton = /*#__PURE__*/ React.createElement(Button, {
        caption: buttonCaption,
        className: "edit-subscription__button",
        "data-t": "edit-subscription-modal-confirm",
        disabled: isLoading,
        onClick: handleSubmit
    });
    return /*#__PURE__*/ React.createElement(Modal, {
        showIcon: true,
        isOpen: true,
        onModalClose: onCancel,
        title: intl.getLabel('account.editSubscription.title'),
        footer: footerButton,
        className: classnames('edit-subscription', className)
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        message: intl.getFormattedLabel('account.editSubscription.info', {
            parseLink: true
        })
    }), errorMessage && /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        icon: "warning",
        message: errorMessage
    }), /*#__PURE__*/ React.createElement(Select, {
        id: "edit-quantity-select",
        name: "edit-quantity-select",
        className: "edit-subscription__select",
        options: formattedQuantities,
        initialState: initialValue,
        onChange: onSelectChange,
        label: intl.getLabel('account.editSubscription.select.label')
    }), /*#__PURE__*/ React.createElement("p", null, intl.getLabel('account.editSubscription.newPrice'), ' ', /*#__PURE__*/ React.createElement("b", null, /*#__PURE__*/ React.createElement(Price, {
        value: totalPricePerInstallment.amount * quantity1,
        currency: totalPricePerInstallment.currency
    }))));
};
var ChangeQuantityModal$1 = ChangeQuantityModal;

export { ChangeQuantityModal$1 as default };
//# sourceMappingURL=ChangeQuantity.js.map
